import type {FC} from 'react';
import clsx from 'clsx';

interface Props {
	href: string;
	title: string;
}

const DocumentCard: FC<Props> = ({href, title}) => {
	return (
		<a
			href={href}
			target="_blank"
			className={clsx(
				'hover:underline',
				'font-semibold',
				'text-dypgronn-industri',
				'flex',
				'border',
				'p-5',
			)}
		>
			<svg
				style={{marginRight: '10px'}}
				width="16"
				height="23"
				viewBox="0 0 16 23"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15.4125 4.84867L11.9167 1.31922C11.5417 0.940618 11.0333 0.726074 10.5042 0.726074H2C0.895833 0.730281 0 1.63473 0 2.74951V20.2495C0 21.3643 0.895833 22.2687 2 22.2687H14C15.1042 22.2687 16 21.3643 16 20.2495V6.27896C16 5.7447 15.7875 5.22728 15.4125 4.84867ZM13.8375 6.1149H10.6667V2.91357L13.8375 6.1149ZM2 20.2495V2.74951H8.66667V7.12451C8.66667 7.68401 9.1125 8.13413 9.66667 8.13413H14V20.2495H2Z"
					fill="#005C48"
				></path>
			</svg>
			<span>{title}</span>
		</a>
	);
};

export default DocumentCard;
